import React from "react";
import "./IconBadge.css";

/**
 * Circular icon badge in the style of the client-supplied section badges
 * (MBA_MERN_Solutions/icons): a navy disc with a white glyph, framed by a
 * split ring — navy on the left, brand orange on the right.
 *
 * Decorative: the text beside it always carries the meaning.
 *
 * @param {Component} icon  a react-icons component
 * @param {string}    [size] "sm" | "md" | "lg"
 */
const IconBadge = ({ icon: Icon, size = "md", className = "" }) => (
  <span className={`icon-badge icon-badge--${size} ${className}`} aria-hidden="true">
    <span className="icon-badge__core">
      <Icon />
    </span>
  </span>
);

export default IconBadge;
